/*
 * @Author: DQL
 * @Date: 2020-05-18 16:10:59
 * @LastEditors: DQL
 * @LastEditTime: 2022-01-27 15:19:57
 * @Description: file content
 */
const workflowRoutes = {
  path: 'workflow',
  name: 'workflow',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'workflowIndex',
      name: 'workflowIndex',
      component: () => import(/* webpackChunkName: "workflowIndex" */ '@/features/workflow/index.vue'),
      meta: {
        navtabTitle: '工作流程',
        isCache: true,
        ignoreDiff: ['refreshTab'],
        isSecondary: false
      }
    },
    {
      path: 'gzdl',
      name: 'gzdl',
      component: () => import(/* webpackChunkName: "gzdl" */ '@/features/workflow/gzdl/list.vue'),
      meta: {
        navtabTitle: '工作代理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'deploy',
      name: 'deploy',
      component: () => import(/* webpackChunkName: "deploy" */ '@/features/workflow/deploy/list.vue'),
      meta: {
        navtabTitle: '流程部署',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    },
    {
      path: 'historyView/:processInsId',
      name: 'historyView',
      component: () => import(/* webpackChunkName: "historyView" */ '@/features/workflow/historyView.vue'),
      meta: {
        navtabTitle: '工作流程',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default workflowRoutes;
